/* Simple 1-N pagination bar. */
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ page, total, perPage, onChange }) {
  const pages = Math.max(1, Math.ceil(total / perPage));
  if (pages <= 1) return null;
  const nums = [];
  for (let i = 1; i <= pages; i++) nums.push(i);
  const go = (n) => { onChange(Math.min(pages, Math.max(1, n))); window.scrollTo({ top: 0, behavior: 'smooth' }); };
  return (
    <div className="mt-16 flex items-center justify-center gap-1" data-testid="pagination">
      <button onClick={() => go(page - 1)} disabled={page === 1} className="grid h-10 w-10 place-items-center rounded-full border border-ink-100 bg-white text-ink-700 transition hover:border-cyan hover:text-cyan disabled:opacity-40 disabled:hover:border-ink-100 disabled:hover:text-ink-700">
        <ChevronLeft className="h-4 w-4" />
      </button>
      {nums.map(n => (
        <button key={n} onClick={() => go(n)} data-testid={`page-${n}`} className={`min-w-[40px] h-10 rounded-full px-3 text-sm font-medium transition ${page === n ? 'bg-ink-900 text-white' : 'text-ink-500 hover:text-cyan'}`}>
          {n}
        </button>
      ))}
      <button onClick={() => go(page + 1)} disabled={page === pages} className="grid h-10 w-10 place-items-center rounded-full border border-ink-100 bg-white text-ink-700 transition hover:border-cyan hover:text-cyan disabled:opacity-40 disabled:hover:border-ink-100 disabled:hover:text-ink-700">
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
